// extracted by mini-css-extract-plugin
export default {"errorLabel":"FormInputErrorLabel_errorLabel__kn1M8"};